export const oneSecond = 1000;

// eslit-disable
export const getProductName = (id: number) => {
  const products = [
    'Plotter Epson T3170',
    'Epson EcoTank L3250',
    'PowerLite S27',
    'WF-7620',
    'ET-2500',
  ];
  return products[id % products.length];
};
// eslint-enable

export const isDateInFuture = (date: Date) => {
  const currentDate = new Date();
  return date > currentDate;
};
